import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import pages from './data/pages.json';

import './css/Themes.css';

import Home from './pages/Home';
import About from './pages/About';
import Blog from './pages/Blog';
import Teams from './pages/Teams';
import API from './pages/Api';
import Article from './pages/Article';

import Base from './composant/Base';


function App() {
  return (
    <div>
      <Base></Base>
      <Router>
        <Routes>
          {pages.data.map((val) => {
            switch (val.attributes.title) {
              case '/':
                return (<Route exact path="/" key={0} element={<Home data={val.attributes.Content}></Home>} />);
              case '/about':
                return (<Route path="/about" key={3} element={<About data={val.attributes.Content}></About>} />);
              case '/blog':
                return (<Route path="/blog" key={1} element={<Blog data={val.attributes.Content}></Blog>} />);
              case '/team':
                return (<Route path="/team" key={1} element={<Teams data={val.attributes.Content}></Teams>} />);
              default:
                return (<Route path={val.attributes.title} key={`_${val.id}`} element={<Home data={val.attributes.Content}></Home>} />);
            }
          })}
          <Route path="/blog/:id" key={2} element={<Article></Article>} />
          <Route path="/team/:id" key={5} element={<Teams member={true}></Teams>} />
          <Route path="/team/kirikou" key={5} element={<Teams member={true} memberid={'kirouko'}></Teams>} />

          <Route path="/api/preview" key={4} element={<API></API>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
